import { useEffect, useState } from "react";
import Reveal from "@/components/Reveal";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Publications() {
  const [papers, setPapers] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    document.title = "Publications · QPI Labs";
    fetch(`${API}/api/publications`)
      .then((r) => r.json())
      .then(setPapers)
      .catch(() => setError(true));
  }, []);

  return (
    <main className="pt-16" data-testid="publications-page">
      <section className="border-b border-white/10 py-20 md:py-28">
        <div className="container-x">
          <Reveal>
            <p className="eyebrow mb-6 text-laser">— Research</p>
            <h1 className="max-w-4xl text-5xl font-extrabold tracking-tighter md:text-7xl">
              Publications
            </h1>
            <p className="mt-6 max-w-2xl font-mono text-xs leading-relaxed text-zinc-500">
              White papers and preprints from the QPI Labs team — the physics behind the
              simulator, released as we publish it.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="mx-auto w-full max-w-[860px] px-6">
          {error && (
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-600">
              — Could not load publications
            </p>
          )}
          {!error && papers === null && (
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-600">Loading…</p>
          )}
          {!error && Array.isArray(papers) && papers.length === 0 && (
            <div className="py-10 text-center" data-testid="publications-empty">
              <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-600">
                — First publication coming soon
              </p>
              <p className="mx-auto mt-5 max-w-md font-mono text-xs leading-relaxed text-zinc-500">
                White papers and preprints will appear here as they are released. In the
                meantime, the physics behind the simulator is documented on its Theory page.
              </p>
            </div>
          )}
          {Array.isArray(papers) && papers.length > 0 && (
            <div>
              {papers.map((paper) => (
                <Reveal key={paper.id}>
                  <article
                    className="border-t border-white/10 py-10 first:border-t-0 first:pt-0"
                    data-testid={`publication-${paper.id}`}
                  >
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600">
                      {paper.venue || "QPI Labs Preprint"}
                    </p>
                    <h2 className="mt-3 text-xl font-medium tracking-tight text-zinc-100 md:text-2xl">
                      {paper.title}
                    </h2>
                    {paper.authors && (
                      <p className="mt-2 font-mono text-xs text-zinc-500">{paper.authors}</p>
                    )}
                    <a
                      href={paper.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`publication-link-${paper.id}`}
                      className="mt-4 inline-block font-mono text-[11px] uppercase tracking-[0.25em] text-beam transition-colors hover:underline"
                    >
                      Read paper <span aria-hidden="true">↗</span>
                    </a>
                  </article>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
